import { render, staticRenderFns } from "./EmployeeVerificationEmployeeInformation.vue?vue&type=template&id=24b601ec&scoped=true&"
import script from "./EmployeeVerificationEmployeeInformation.vue?vue&type=script&lang=js&"
export * from "./EmployeeVerificationEmployeeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b601ec",
  null
  
)

export default component.exports